export const mutationTypes = {
  SET_MEETINGS: 'SET_MEETINGS',
  SET_MEETING: 'SET_MEETING',
  ADD_MEETING: 'ADD_MEETING',
  UPDATE_MEETING: 'UPDATE_MEETING',
  REMOVE_MEETING: 'REMOVE_MEETING',
  SET_AGENDA: 'SET_AGENDA',
  SET_UI_FLAG: 'SET_UI_FLAG',
};

export default {
  [mutationTypes.SET_MEETINGS](state, meetings) {
    state.meetings = meetings;
  },
  [mutationTypes.SET_MEETING](state, meeting) {
    state.meeting = meeting;
  },
  [mutationTypes.ADD_MEETING](state, meeting) {
    state.meetings = [meeting, ...state.meetings];
  },
  [mutationTypes.UPDATE_MEETING](state, meeting) {
    state.meetings = state.meetings.map(m =>
      m.id === meeting.id ? meeting : m
    );
    if (state.meeting?.id === meeting.id) state.meeting = meeting;
  },
  [mutationTypes.REMOVE_MEETING](state, meetingId) {
    state.meetings = state.meetings.filter(m => m.id !== meetingId);
    if (state.meeting?.id === meetingId) state.meeting = null;
  },
  [mutationTypes.SET_AGENDA](state, agenda) {
    state.agenda = agenda;
  },
  [mutationTypes.SET_UI_FLAG](state, flags) {
    state.uiFlags = { ...state.uiFlags, ...flags };
  },
};
